import Cards from "./Cards";
import Filter from "./Filter";
import Graph from "./Graph";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import PieChart from "./PieChart";
import { pieData } from "../../mockdata/overview";

export default function Overview() {
  return (
    <div className={tw`h-fit`}>
      <Filter />
      <Cards />
      <div className={tw`grid grid-cols-2 gap-4`}>
        <Graph />
        <PieChart data={pieData} />
      </div>
    </div>
  );
}
